import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import permissionPolicyDTO, { PermissionPolicyDTO } from '../../../../domain/permission/PermissionPolicyDTO'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import serializeToJsonString = com.eidu.entity.util.serializeToJsonString
import Permission = com.eidu.entity.permission.Permission
import PermissionPolicy = com.eidu.entity.permission.PermissionPolicy
import CreatePermissionPolicyRequest = com.eidu.entity.api.permissions.CreatePermissionPolicyRequest
import NonEmptySet = com.quickbirdstudios.nonEmptyCollection.set.NonEmptySet

export type CreatePermissionPolicyParameters = {
  name: string
  permissions: readonly Permission[]
}

const createPermissionPolicy = async ({
  name,
  permissions,
}: CreatePermissionPolicyParameters): Promise<PermissionPolicyDTO> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/policies`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(
        new CreatePermissionPolicyRequest(new PermissionPolicy(name, NonEmptySet.fromArray([...permissions])))
      ),
      method: 'POST',
    }
  ).then(async (response) => {
    if (response.status !== 201)
      throw Error(`Unexpected response code ${response.status} from createPermissionPolicy endpoint`)
    return permissionPolicyDTO((await response.json()).document)
  })
}

export default createPermissionPolicy
